import { IS_AGENT } from 'core/constants/environment'
import { getVariant } from 'core/experiment'
import {
  PPI_27_ESIG_CHECKOUT,
  PPI_27_ESIG_CHECKOUT_VARIANTS
} from 'core/constants/experiments'

export function enableESignature(): boolean {
  if (!IS_AGENT) return false

  const variant = getVariant({
    experimentKey: PPI_27_ESIG_CHECKOUT,
    fallback: PPI_27_ESIG_CHECKOUT_VARIANTS.ON
  })

  return variant === PPI_27_ESIG_CHECKOUT_VARIANTS.ON
}
